import template from './photo-capture.html';
import modalTemplateUrl from './photo-capture.ngtemplate.html';
import stampit from 'stampit';
import OT from '@opentok/client';
import 'ng-file-upload';
import { get } from 'lodash';
import { VideoQuality } from '../../../modules/call/constants';

const componentName = 'photoCapture';
const serviceName = 'PhotoCaptureRealtimeComponent';
const moduleName = 'doxy.realtime.components.photo-capture';

export { componentName, serviceName, moduleName };

export default angular
  .module(moduleName, ['ngFileUpload'])
  .directive('dImageModal', function () {
    return {
      template,
      restrict: 'E',
      scope: {
        state: '<',
      },
    };
  })
  .factory(
    'PhotoCaptureRealtimeComponent',
    function (
      $rootScope,
      $log,
      RealtimeComponent,
      currentUserHelper,
      notificationFactory,
      publisherManager,
      $q,
      VideoProviderFactory,
      Browser,
      apiUrl,
      User,
      Upload,
      $ngRedux,
      $translate
    ) {
      return stampit({
        deepProps: {
          componentName,
          $scope: null,
          innerMediator: null,
          target: null,
          peopleAvailable: null,
          basePath: '',
          hasMobileSupport: false,
          name: 'Photo Capture',
          events: {
            upload: 'onUpload',
            requestFile: 'onRequestFile',
            requestFileFailed: 'onRequestFileFailed',
          },
          innerMediatorEvents: {
            cancel: 'close',
          },
        },
        methods: {
          open({ target, peopleAvailable }) {
            const people =
              peopleAvailable ||
              VideoProviderFactory.activeProvider.peopleCollection;
            this.target = target || people.models[0];

            const patientStream =
              VideoProviderFactory.activeProvider.findStreamByPatient(
                this.target
              );

            if (!patientStream.hasVideo) {
              notificationFactory.showCommon(
                'info',
                `Can't capture an image, please make sure ${
                  this.target.state.username || 'patient'
                } has their camera enabled`
              );
              return;
            }

            this.close();
            this.state = {
              patientName: this.target.state.username,
              fileName: this.getFileName(this.target.state.username),
            };

            this.createInnerMediator();
            this.createScope(['state']);

            // We can't take HD photos on iOS
            const isPatientIOS = get(this.target, 'state.system.os') === 'ios';

            const shouldTakeStreamPhoto =
              currentUserHelper.user.lowQualityPhoto ||
              this.target.isUndetermined ||
              isPatientIOS;

            const method = shouldTakeStreamPhoto
              ? 'takeStreamPhoto'
              : 'takeTransferPhoto';
            this[method]();

            this.openModal({
              contentTemplate: modalTemplateUrl,
              backdrop: true,
            });
            this.$scope.$once('modal.hide', this.close.bind(this));
          },

          close() {
            $log.debug('Photo capture close');
            if (!this.$scope) return;
            this.hideModal();
            this.reset();
          },

          takeStreamPhoto() {
            const patientStream =
              VideoProviderFactory.activeProvider.findStreamByPatient(
                this.target
              ) || VideoProviderFactory.activeProvider.streams[0];

            this.state.type = 'stream';
            const image = patientStream.getImgData();
            this.state.file = image;
          },

          takeTransferPhoto() {
            this.state.type = 'file';
            this.state.notificationsStatus = 'PENDING';
            User.createCurrentPatientToken().$promise.then((token) => {
              this.sendToTarget('requestFile', { token: token.id });
            });
          },

          onUpload(file, person) {
            if (this.target && this.target !== person) return;
            this.state.notificationsStatus = 'SUCCESS';
            this.state.file = file;
          },

          getFileName(patientName) {
            return `patient-photo(${encodeURI(
              patientName.replace(/[^\w_-]/gi, '-')
            )}).png`;
          },

          requestFileFailed() {
            this.sendToTarget('requestFileFailed');
          },

          onRequestFileFailed() {
            notificationFactory.showCommon(
              'info',
              $translate.instant(
                'realtimeComponents.photoCapture.action.capture-error'
              )
            );
            this.close();
          },

          onRequestFile(data, person) {
            if (!person.isDoctor()) return;
            this.target = person;
            const currentDevices = $ngRedux.getState().devices.current;
            const props = {
              ...VideoProviderFactory.activeProvider.qualityConfig[
                VideoQuality.High
              ],
              audioSource: null,
            };

            if (currentDevices && currentDevices.cameraId) {
              props.videoSource = currentDevices.cameraId;
            }
            let publisher;
            try {
              publisher = OT.initPublisher(null, props);
            } catch (e) {
              this.requestFileFailed();
              return;
            }

            publisher.on('loaded', () => {
              const photoData = publisher
                .getImgData()
                .split('data:image/png;base64,')
                .join('');
              publisher.destroy();

              const file = publisherManager.b64toBlob(photoData, 'image/png');
              file.name = this.getFileName(this.userState.username);

              Upload.upload({
                url: apiUrl + '/api/privateStorages/uploadFile',
                file: file,
                params: {
                  token: data.token,
                  temporary: true,
                },
              })
                .success((data) => {
                  this.sendToTarget('upload', {
                    url: data.url,
                    name: file.name,
                    size: file.size,
                  });
                })
                .error(() => {
                  this.requestFileFailed();
                });
            });
          },

          reset() {
            this.hideModal();
            if (this.innerMediator) this.innerMediator.removeAllListeners();
            if (this.$scope) this.$scope.$destroy();
            this.$scope = this.target = this.innerMediator = null;
          },
        },
      }).compose(RealtimeComponent);
    }
  ).name;
